import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    langStates:'zh',
    token: localStorage.getItem("token"),
    active:0
  },
  mutations: {
    updateLang(state,lang){
      state.langStates = lang
    },
    updateToken(state,t){
      state.token = t
    },
    changeA(state,v){
      console.log('active改变',v);
      state.active = v
    }
  },
  actions: {
  },
  modules: {
  }
})
